import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const TermsOfUse = () => {
  return (
    <Container className="my-5 mt-5">
      <Row className="justify-content-center">
        <Col xs={12}>
          <h3 className="text-center mb-4">Terms of Use</h3>
          <p>
            Welcome to <strong>The Challenge Of Everest Board Game</strong>.
            These Terms of Use govern your use of our website. By accessing or
            using our website, you agree to comply with these terms.
          </p>

          <h5>1. Website Content</h5>
          <p>
            All content provided on our website is for informational purposes
            only. We strive to ensure the accuracy and timeliness of the
            information, but we make no guarantees.
          </p>

          <h5>2. Intellectual Property</h5>
          <p>
            The content, logos, trademarks, and other intellectual property
            displayed on our website are owned by Dr Sumeet Mandale. You may not
            use, reproduce, or distribute our intellectual property without
            prior written consent.
          </p>

          <h5>3. User Conduct</h5>
          <p>
            You agree not to use our website for any unlawful or prohibited
            purposes. You also agree not to interfere with the security or
            functionality of our website.
          </p>

          <h5>4. Third-Party Links</h5>
          <p>
            Our website may contain links to third-party websites. We are not
            responsible for the content or privacy practices of these websites.
          </p>

          <h5>5. Data Privacy</h5>
          <p>
            We are committed to protecting your privacy. Any personal
            information you provide to us will be handled in accordance with our
            Privacy Policy.
          </p>

          <h5>6. Limitation of Liability</h5>
          <p>
            The Challenge Of Everest Board Game shall not be liable for any
            direct, indirect, incidental, or consequential damages arising out
            of your use of our website.
          </p>

          <h5>7. Governing Law</h5>
          <p>
            These Terms of Use are governed by the laws of India. Any disputes
            arising from these terms shall be subject to the exclusive
            jurisdiction of the courts in Maharashtra, India.
          </p>

          <h5>8. Changes to Terms</h5>
          <p>
            We reserve the right to modify or update these Terms of Use at any
            time. Please review this page periodically for changes.
          </p>

          <p>
            By using our website, you acknowledge that you have read and
            understood these Terms of Use and agree to abide by them.
          </p>

          <p className="text-center mt-4">
            <strong>
              Copyright &copy; 2025 Dr Sumeet Mandale. All rights reserved.
            </strong>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default TermsOfUse;
